import { render, staticRenderFns } from "./LongHaulPricing.vue?vue&type=template&id=0395577c"
var script = {}
import style0 from "./LongHaulPricing.vue?vue&type=style&index=0&id=0395577c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports